import { create } from 'zustand';
import { supabase } from '../lib/supabase';
import type { Project, ProjectStatus } from '../types/project';
import { transformRawQuoteToQuote, RawQuote } from '../types/quote';

interface ProjectState {
  projects: Project[];
  loading: boolean;
  error: string | null;
  fetchProjects: () => Promise<void>;
  updateProjectStatus: (projectId: string, status: ProjectStatus) => Promise<void>;
}

export const useProjectStore = create<ProjectState>((set, get) => {
  return {
    projects: [],
    loading: false,
    error: null,

    fetchProjects: async () => {
      if (get().loading) return;
      set({ loading: true });
      try {
        const { data, error } = await supabase.rpc('fetch_user_projects');

        if (error) throw error;

        const projects = (data || []).map((p: RawQuote) => ({
          quote: transformRawQuoteToQuote(p),
        }));

        set({ projects, error: null });
      } finally {
        set({ loading: false });
      }
    },

    updateProjectStatus: async (projectId: string, status: ProjectStatus) => {
      const { error } = await supabase.rpc('update_project_status', {
        project_job_id: projectId,
        new_status: status,
      });

      if (error) throw error;

      await get().fetchProjects();
    },
  };
});
